import { View, Text } from 'tamagui'

export function PdfViewer({
  fileUrl,
  closeModal,
}: {
  fileUrl: string
  closeModal: () => void
}) {
  console.log('fileUrl', fileUrl, closeModal)
  return (
    <View>
      <Text>PDF viw </Text>
    </View>
  )
}
